export class Popup {
	static isOnPage() {
		return $('.js-popup-container').length !== 0;
	}

	constructor() {
		this.init();
		this.addEventListeners();
	}

	init() {
		$('.js-popup-trigger').magnificPopup({
			closeBtnInside: true,
			type: 'inline',
      focus: '.mfp-close',
      callbacks: {
        open: () => {
          this.setupNewsletterPopup();
        }
      }
		});
	}

  setupNewsletterPopup() {
    const $newsletterPopup = $('#newsletter-signup-popup');

    if($newsletterPopup.length !== 0) {
      const dataLabelValue = $newsletterPopup.attr('data-aria-label') || '';

      $newsletterPopup.find('.mfp-close').attr('tabindex', '1');
      $newsletterPopup.find('.mfp-close').attr('aria-label', dataLabelValue);
    }
  }

	addEventListeners() {
		$('.js-popup-close').on('click', () => $.magnificPopup.instance.close());
	}
}
